import { render, staticRenderFns } from "./UnBindServer.vue?vue&type=template&id=1799112e"
import script from "./UnBindServer.vue?vue&type=script&lang=js"
export * from "./UnBindServer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports